export enum EMkStorageKeys {
  LOGIN_ORIGIN = 'loginOrigin',
  MAKO_SESSION = 'makoSession',
  MK_THEME_BRAND = 'mkThemeBrand',
  MAKO_BOOK_SESSION = 'makoBookSession',
  MAKO_RECENT_SEARCHES = 'recentSearches',
  MAKE_CURRENT_LOCATION = 'currentLocation',
  MAKO_EXPLORE_LOCATIONS_REGIONS = 'exploreLocationsRegions',
  MAKO_RESORTS = 'makoResorts',
  MAKO_BOOK_TIMER = 'mako_book_timer',
  MAKO_API_CONTEXT = 'mako_api_context',
  SEARCH_MAP_MODE = 'searchMapMode',
  DEV_UI_LAST_SELECTED_STEP = 'devUiLastSelectedStep',
  MAKO_REGISTRATION_CONTEXT = 'makoRegistrationContext',
  MAKO_ACCOUNT_LOCKOUT = 'makoAccountLockout',
  REDIRECT_URL = 'redirectUrl',
  VIEWED_RESORTS = 'viewedResorts',
  MAKO_AUTH_TOKENS_EXPIRES_AT = 'makoAuthTokensExpiresAt',
  /** Set before OAuth redirect after registration MFA verify; cleared either by the post-login landing page after the snackbar is shown once or by LoginCallback in the redirectUrl full-page redirect branch. */
  PENDING_REGISTRATION_MFA_LOGIN_SUCCESS = 'pendingRegistrationMfaLoginSuccess',
}
export interface EMkStorageOpts {
  defaultValue?: any | null
  parse?: boolean
  store?: Storage
  expirationTime?: number | null
}
export abstract class DataStore {
  public static getItem<T = any>(key: EMkStorageKeys | string, opts?: EMkStorageOpts): T | null {
    const { defaultValue = null, parse = true, store = sessionStorage } = { ...opts }
    const item = store.getItem(key)

    // if (process.env.NODE_ENV === 'development') {
    // }

    return item ? ((parse ? JSON.parse(item) : item) as T) : defaultValue || null
  }

  public static setItem<T = any>(key: EMkStorageKeys | string, value: T, opts?: EMkStorageOpts): void {
    const { store = sessionStorage } = { ...opts }

    store.setItem(key, JSON.stringify(value))
  }

  public static removeItem(key: EMkStorageKeys | string, opts?: EMkStorageOpts): void {
    const { store = sessionStorage } = { ...opts }

    store.removeItem(key)
  }

  public static bulkRemoveItems(keys: EMkStorageKeys[] | string[], opts?: EMkStorageOpts): void {
    const { store = sessionStorage } = { ...opts }
    keys.forEach((key) => this.removeItem(key, { store }))
  }

  public static clearAll(opts?: EMkStorageOpts): void {
    const { store = sessionStorage } = { ...opts }

    store.clear()
  }
}
